import React from 'react';
import { useStyle } from '../../classify';
import defaultClasses from './text.module.css';
import { useHistory } from 'react-router-dom';
import handleHtmlContentClick from '../../handleHtmlContentClick';

import htmlStringImgUrlConverter from '../../htmlStringImgUrlConverter';

const toHTML = str => ({ __html: htmlStringImgUrlConverter(str) });

const Text = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const {
        content,
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        cssClasses = []
    } = props;

    const dynamicStyles = {
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    };

    const history = useHistory();

    const clickHandler = event => {
        handleHtmlContentClick(history, event);
    };

    return (
        <div
            style={dynamicStyles}
            className={[classes.root, ...cssClasses].join(' ')}
            dangerouslySetInnerHTML={toHTML(content)}
            onClick={clickHandler}
            onKeyDown={clickHandler}
            role="presentation"
        />
    );
};

export default Text;
